import { Dispatch } from 'redux';
import { Action, AvailableModalActions } from '../../store';
import { pepperApi } from 'modules/cm/api';
import {
  setModalScreen,
  setValidationErrors,
  setValidationStart,
  setValidationSuccess,
} from 'modules/cm/pages/CaseDetailsPage/Pepper/store/actions';
import { guard } from 'modules/cm/pages/CaseDetailsPage/Pepper/errors';
import * as sharedCaseActions from 'modules/cm/store/sharedActions';

const reducer = () => {
  return async (dispatch: Dispatch<Action>, getState: any) => {
    dispatch(setValidationStart());
    const api = pepperApi(getState().currentCase.data.case.identifier);
    try {
      await api.validateData();

      dispatch(setModalScreen(AvailableModalActions.VALIDATE_OK));
      dispatch(setValidationSuccess());
      await sharedCaseActions.setCasePepperError(null)(dispatch as Dispatch);
    } catch (e) {
      if (guard.isPepperValidationError(e)) {
        await sharedCaseActions.setCasePepperError(e.getErrors())(dispatch as Dispatch);
        dispatch(setValidationErrors(e.getErrors()));
        dispatch(setModalScreen(AvailableModalActions.VALIDATE_FAILED));
      } else {
        dispatch(setValidationErrors(null));
        dispatch(setModalScreen(AvailableModalActions.GENERAL_ERROR));
      }
    }
  };
};

export default reducer;
